module.exports = __webpack_public_path__ + "static/media/mobile-payments.80ac7937.svg";